import { makeFilterByCodeName } from '../SelectModal/makeFilterByCodeName'
import { ICryptoCurrency, INetwork } from '../../api/types'
import { Step } from '.'

export const checkNetworksAvailable = (selectedCurrency: ICryptoCurrency | null) => !!selectedCurrency?.networks?.length

type GetListProps = {
  step: Step
  options: ICryptoCurrency[]
  selectedCurrency: ICryptoCurrency | null
  searchQuery: string
}

export const getList = ({ step, options, selectedCurrency, searchQuery }: GetListProps) => {
  const isCoinStep = step === 'coin'
  const isNetworksAvailable = checkNetworksAvailable(selectedCurrency)

  let displayedList: (ICryptoCurrency | INetwork)[] = []

  if (isCoinStep) {
    displayedList = options
  } else if (isNetworksAvailable) {
    displayedList = selectedCurrency?.networks ?? []
  }

  let filteredOptions = displayedList.sort((a, b) => a.name.localeCompare(b.name))

  filteredOptions = isCoinStep ? filteredOptions.filter(makeFilterByCodeName(searchQuery)) : filteredOptions

  return filteredOptions
}

type GetIconProps = {
  option: ICryptoCurrency | INetwork
  step: Step
  selectedCurrency: ICryptoCurrency | null
  currencies: ICryptoCurrency[]
}

export const getIcon = ({ option, step, selectedCurrency, currencies }: GetIconProps) => {
  if (step === 'coin') {
    return {
      icon: (option as ICryptoCurrency).icon_url,
    }
  }

  if (step === 'network') {
    return {
      icon: selectedCurrency?.icon_url,
      badge: currencies.find(currency => currency.code === option.code)?.icon_url,
    }
  }
}
